// src/components/HomePage.jsx
import React from 'react';
import HeroSection from './HeroSection';
import CountdownSection from './CountdownSection';
import AboutSection from './AboutSection';
import FocusAreas from './FocusAreas';
import HealthInitiative from './HealthInitiative';
import ContactSection from './ContactSection';
import './HomePage.css';

const HomePage = () => {
  return (
    <div className="homepage">
      <HeroSection />
      <CountdownSection />
      <AboutSection />
      <FocusAreas />
      <HealthInitiative />
      <ContactSection />
    </div>
  );
};

export default HomePage;